import { isNullOrEmpty } from "../../../../../../react-core/Utils/Arrays";
import { SubAccountType } from "../../../../../../Wrap/Constants/Enums/Domain/SubAccountType";
import { ClientAccount } from "../../../../../../Wrap/Models/Domains/Account/SlAccounts/ClientAccount";
import { Action } from "../../../../Actions/Action";
import { ClientAccountStore } from "../../../../Stroes/Variable";

export class SubAccountTypeHelper {
    static isOnPlatformPension(type: SubAccountType) {
        return type === SubAccountType.Pension || type === SubAccountType.Npr;
    }

    static isIsa(type: SubAccountType) {
        return type === SubAccountType.StocksIsa || type === SubAccountType.CashIsa;
    }

    static isSIPP(type: SubAccountType) {
        return type === SubAccountType.Sipp || type === SubAccountType.JuniorSipp || type === SubAccountType.RetailSipp;
    }

    static isPP(type: SubAccountType) {
        return type === SubAccountType.PersonalPortfolio || type === SubAccountType.InvestmentAccount;
    }

    static isWrapCash(type: SubAccountType) {
        return type == SubAccountType.WrapCash || type == SubAccountType.CashAccount;
    }

    static isCashAccount(type: SubAccountType) {
        return this.isWrapCash(type) || type == SubAccountType.CashIsa;
    }

    static isBond(type: SubAccountType) {
        return type == SubAccountType.OnshoreBond || type == SubAccountType.OffshoreBond;
    }

    static isOffPlatformPension(type: SubAccountType) {
        return type === SubAccountType.Sipp
    }

    static isUnlistedProduct(type: SubAccountType) {
        return type === SubAccountType.CashIsa;
    }

    static isLegacyProduct(type: SubAccountType) {
        return this.isBond(type) || this.isOffPlatformPension(type);
    }

    static productEligibleForJoint(type: SubAccountType) {
        return this.isOnPlatformPension(type) == false && this.isIsa(type) == false && this.isOffPlatformPension(type) == false;
    }

    static isPPAndISA(type: SubAccountType) {
        return this.isIsa(type) || this.isPP(type);
    }

    static getSubAccountHierarchyId(hierarchyid: string, type: SubAccountType, callback) {
        const clientaccount = ClientAccountStore.getClientAccountInfo();
        if (!clientaccount) {
            Action.getClientAccount(hierarchyid, (data) => {
                callback(SubAccountTypeHelper.getHierarhyId(data, type));
            });
        } else {
            callback(SubAccountTypeHelper.getHierarhyId(clientaccount, type));
        }
    }

    static getHierarhyId(clientaccount: ClientAccount, type: SubAccountType) {
        if (clientaccount && !isNullOrEmpty(clientaccount.SubAccounts)) {
            const subaccount = clientaccount.SubAccounts.find((x) => x.SubAccountType === type);
            if (subaccount) {
                return subaccount.HierarchyId;
            }
        }
        return null;
    }
}
